import { render } from "./AiReportsTab.vue?vue&type=template&id=218afc4c&scoped=true"
import script from "./AiReportsTab.vue?vue&type=script&lang=js"
export * from "./AiReportsTab.vue?vue&type=script&lang=js"

import "./AiReportsTab.vue?vue&type=style&index=0&id=218afc4c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218afc4c"]])

export default __exports__